/**
 * Example JavaScript singleton module
 */

var Backgrounds = (function($) {

  function initBackgrounds() {
    // store the image link inside a variable from 'src' attribute
    var getImageSrc = $('.hero-article__image').attr('src');
    var getImageBannerSrc = $('.banner__image').attr('src');
    var getImageCornerLeftSrc = $('.corners--left .corners__image img').attr('src');
    var getImageCornerRightSrc = $('.corners--right .corners__image img').attr('src');



    
    // add div background image using the variable above
    $('.hero-article--right').css('background-image', 'url(' + getImageSrc + ')');
    $('.banner--bg').css('background-image', 'url(' + getImageBannerSrc + ')');
    $('.corners--left .corners__image').css('background-image', 'url(' + getImageCornerLeftSrc + ')');
    $('.corners--right .corners__image').css('background-image', 'url(' + getImageCornerRightSrc + ')');

}

  function init() {

    initBackgrounds();

  }

  return {
    init: init
  };

}(jQuery));

jQuery(document).ready(Backgrounds.init);
